import { DESKTOP_MAX_SIZE } from "@/constants/screen";
import { Select } from "@getgrover/ui";
import styled from "styled-components";

export const ModalBody = styled.div`
  margin-top: ${({ theme }) => theme.spacers.L};
  margin-bottom: ${({ theme }) => theme.spacers.XL};
`;

export const ModalHeading = styled.h2`
  ${({ theme }) => theme.typography.SmallHeadline};
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  margin-bottom: ${({ theme }) => theme.spacers.L};
`;

export const ModalParagraph = styled.p`
  ${({ theme }) => theme.typography.RegularParagraph};
  color: ${({ theme }) => theme.colors.text.darkGrey};
  margin-bottom: ${({ theme }) => theme.spacers.XXL};
`;

export const ModalFooter = styled.div`
  padding: ${({ theme }) => `${theme.spacers.L} 0 ${theme.spacers.M} 0`};
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacers.L};
`;

/* TODO: Remove this after fixing the issue on the radix select component https://grover.atlassian.net/browse/AQ-1060 */
export const StyledSelect = styled(Select).attrs<{ $isDesktop: boolean }>(
  ({ theme, $isDesktop }) => {
    const maxWidth = $isDesktop
      ? `calc(${DESKTOP_MAX_SIZE} - ${theme.spacers.XXL})`
      : "calc(100vw - 64px)";

    return {
      contentStyles: {
        maxWidth,
        justifySelf: "center",
        zIndex: 100,
      },
    };
  },
)``;
